import React, {ComponentType} from "react";
import styled from "styled-components";
import {Link} from "react-router-dom";
import {Box, Text, Icon} from "@unibuddy/patron";

type MenuItemProps = {
    icon: ComponentType<React.ReactNode>;
    text: string;
    active: boolean;
    color: string;
    to: string;
    show: boolean;
    closeNavigationMenu: () => void;
    trackClickEvent: () => void;
};

const StyledLink = styled(Link)`
    text-decoration: none;

    &:focus,
    &:hover,
    &:visited,
    &:link,
    &:active {
        text-decoration: none;
    }
`;

const MenuItem: React.FC<MenuItemProps> = ({
    icon,
    text,
    active,
    color,
    to,
    show = false,
    closeNavigationMenu,
    trackClickEvent,
}) => {
    const closeMenuAndNavigate = () => {
        trackClickEvent();
        closeNavigationMenu();
    };
    return (
        <Box display={show ? "block" : "none"}>
            <StyledLink to={to} onClick={() => closeMenuAndNavigate()}>
                <Box
                    display="flex"
                    alignItems="center"
                    gap="xxsmall"
                    padding="small"
                    borderBottomWidth={2}
                    borderColor="#F3F5F5"
                >
                    <Icon icon={icon} size="medium" color={active ? color : "black"} />
                    <Text size="large" color={active ? color : "black"} weight={active ? 600 : 400}>
                        {text}
                    </Text>
                </Box>
            </StyledLink>
        </Box>
    );
};

export default MenuItem;
